var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTeacherBorder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#8C52FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 29C10.5 28.0909 12.4 26.2727 16 26.2727C19.6 26.2727 21.5 24.0909 22 23M16 16V13C16 11.8954 16.8954 11 18 11H28C29.1046 11 30 11.8954 30 13V21C30 22.1046 29.1046 23 28 23H24.7397M20 15H26M18 21C18 22.1046 17.1046 23 16 23C14.8954 23 14 22.1046 14 21C14 19.8954 14.8954 19 16 19C17.1046 19 18 19.8954 18 21Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23 19H26",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeacherBorder);
export default __webpack_public_path__ + "static/media/teacher-border.c54c317b3ef1572a9dc2b7d4eef0c5e8.svg";
export { ForwardRef as ReactComponent };